
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificates",
      function () {
        return require("private-next-pages/certificates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificates"])
      });
    }
  